import { Outlet } from "react-router-dom";
import { styled } from '@mui/material/styles';
import Nav from "./nav";
import { useState } from "react";
import Header from "./header";
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const DashboardView = () => {
  const [open, setOpen] = useState<boolean>(true);
  const [openNavDesktopScreen, setOpenNavDesktopScreen] = useState<boolean>(true);

  const theme = useTheme();
  const isLgScreen: boolean = useMediaQuery(theme.breakpoints.up('lg'));

  const Main = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
      paddingTop: APP_BAR_DESKTOP + 24,
     
    },
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  }));

  return (
    <StyledRoot>
      <Header onOpenNavDesktopScreen={() => setOpenNavDesktopScreen(true)} onOpenNav={() => setOpen(true)} openNavDesktopScreen={openNavDesktopScreen} isLgScreen={isLgScreen} />
      {
        ((isLgScreen && openNavDesktopScreen) || !isLgScreen)
        &&
        <Nav isLgScreen={isLgScreen} onCloseNavDesktopScreen={()=>setOpenNavDesktopScreen(false)} openNav={open} onCloseNav={() => setOpen(false)} openNavDesktopScreen={openNavDesktopScreen} />
      }
      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  )
}
export default DashboardView;